<template>
    <div>
        <view-item v-if="showDisplayForm" :item="selectedType" @show-item="showItem" :tabIndex="tabIndex"
            @success="alertSuccess" @danger="alertDanger" @delete-item="deleteType" @cancel="cancel"></view-item>

        <b-overlay v-else :show="tableLoading" rounded="sm">
            <import-form
            :subject="$translate('workflow')"
            v-model="importModal"
            @cancel="hideModal()"
            :fields="inventoryFields"
            :upload-record="uploadInventoryRecord"
            :isworkflow="isworkflow"
            settings-key-name="WorkflowUploadKey"
          ></import-form>
            <list-items title="Review Types" :items="checkoffTypes" @show-item="showItem" ref="table">
               
              <div
              class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button"
          >
              <b-button
              id="add-checkoff-btn"
              variant="blue-icon"
              v-b-tooltip.hover
              :title="$addLabel()"
              v-if="hasPermissionCreate"
              @click="addType"
              >
              <img src="@/assets/images/icon/gradient-add.svg" />
              </b-button>

              <b-button
              id="import-checkoff-item-btn"
              variant="blue-icon"
              v-b-tooltip.hover
              :title="$translate('import')"
              @click="openModel()"
              v-if="hasPermissionCreate"
            >
              <img src="@/assets/images/icon/import.svg" />
            </b-button>
            <b-button
            id="export-checkoff-item-btn"
            variant="blue-icon"
            v-b-tooltip.hover
            :title="$translate('export')"
            @click="export_workflow()"
            v-if="hasPermissionCreate"
          >
            <img src="@/assets/images/icon/export.svg" />
          </b-button>
          </div>
        
            </list-items>
        </b-overlay>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import utilityMixins from '@/mixins/utilityMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import importMixins from "@/mixins/importMixins";
import ImportForm from "@/components/ImportForm.vue";

const inventoryFields = [
  { name: "name", label: "name", required: true, type: "text" },
 
  {
    name: "description",
    label: "description",
    required: false,
    type: "text",
  },
  {
    name: "reasons",
    label: "reasons",
    required: false,
    type: "text",
  },
  {
    name: "is_mandatory",
    label: "is_mandatory",
    required: false,
    type: "text",
  },
  {
    name: "is_mandatory_value_type_format",
    label: "is_mandatory_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },
  {
    name: "do_release",
    label: "do_release",
    required: false,
    type: "text",
  },
  {
    name: "do_release_value_type_format",
    label: "do_release_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },
  {
    name: "attachment_required",
    label: "attachment_required",
    required: false,
    type: "text",
  },
  {
    name: "attachment_required_value_type_format",
    label: "attachment_required_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },
  {
    name: "signature_required",
    label: "signature_required",
    required: false,
    type: "text",
  },
  {
    name: "signature_required_value_type_format",
    label: "signature_required_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },

  {
    name: "ext_acc_bill_generate",
    label: "ext_acc_bill_generate",
    required: false,
    type: "text",
  },
  {
    name: "ext_acc_bill_generate_value_type_format",
    label: "ext_acc_bill_generate_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },
  {
    name: "roles",
    label: "roles",
    required: false,
    type: "text",
  },
 

];
export default {
    name: 'reviewTypes',
    components: {
        ListItems,
        ViewItem,
        ImportForm
    },
    mixins: [popupMixins, permissionsMixins, utilityMixins,importMixins],
    data: () => {
        return {
            tabIndex: 0,
            showDisplayForm: false,
            tableLoading: false,
            importModal: false,
            inventoryFields,
            isworkflow : 'yes',
        }
    },

    created() {
        this.$store.dispatch('roles/fetchAll')
        this.tableLoading = true;
        this.$store.dispatch('checkoffTypes/fetchAll')
        this.tableLoading = false;
    },
    computed: {
        componentName() { return this.$translate('review_type') },
        checkoffTypes() {
            const types = this.$store.state.checkoffTypes.types
            console.log('types', types)
            return types
        },
        selectedType() {
            const selectedType = this.$store.state.checkoffTypes.selectedType
            console.log('selectedType', selectedType)
            return selectedType
        },
    },
    watch: {
        'selectedType.id': function (to) {
            if (to) this.showDisplayForm = true
        },
    },

    methods: {
        cancel() {
            this.$store.commit('checkoffTypes/SET_NULL_TYPE')
            this.showDisplayForm = false
            this.$store.dispatch('checkoffTypes/fetchAll')
        },
        showItem(id) {
            this.$store.dispatch('checkoffTypes/fetchById', id)
            this.tabIndex = 0
        },
        alertSuccess(action, name, message) {
            this.$store.commit('checkoffTypes/SET_NULL_TYPE')
            if (action == 'Created') {
                this.showDisplayForm = true
                this.tabIndex = 1
            }
            this.showDisplayForm = false
            this.genericToast(
                this.componentName,
                action,
                'success',
                `"${name}" ${message}`
            )
        },
        alertDanger(action, message) {
            this.genericToast(
                this.componentName,
                action,
                'danger',
                message,
            )
        },
        addType() {
            this.$store.commit('checkoffTypes/SET_NULL_TYPE')
            this.tabIndex = 0
            this.showDisplayForm = true
        },
        async uploadInventoryRecord(
      dataRecord,
      statusRecord,
      { check, message, field },
      statuses,
      setLoading
    ) {
      try {
        let {
          name,
          description,
          reasons,
          is_mandatory, 
          do_release,
          attachment_required,
          signature_required,
          ext_acc_bill_generate, 
          roles,
         
        } = dataRecord;

      

      

        const is_mandatory_value_types = [
          {
            'name': 'Yes',
            'id': 1,
          },
          {
            'name': 'No',
            'id': 0,
          }
        ]

        is_mandatory = is_mandatory || 0;
        is_mandatory = is_mandatory.trim();
        let is_mandatory_value_type_option = this.getCustomEntityId(
            is_mandatory,
          is_mandatory_value_types,
          "name",
          "Is Mandatory"
        );
        
        do_release = do_release || 0;
        do_release = do_release.trim();
        let do_release_value_type_option = this.getCustomEntityId(
          do_release,
          is_mandatory_value_types,
          "name",
          "Do Release"
        );

        attachment_required = attachment_required || 0;
        attachment_required = attachment_required.trim();
        let attachment_required_value_type_option = this.getCustomEntityId(
          attachment_required,
          is_mandatory_value_types,
          "name",
          "Attachment Required"
        );

        signature_required = signature_required || 0;
        signature_required = signature_required.trim();
        let signature_required_value_type_option = this.getCustomEntityId(
            signature_required,
          is_mandatory_value_types,
          "name",
          "Signature Required"
        );
        ext_acc_bill_generate = ext_acc_bill_generate || 0;
        ext_acc_bill_generate = ext_acc_bill_generate.trim();
        let ext_acc_bill_generate_value_type_option = this.getCustomEntityId(
          ext_acc_bill_generate,
          is_mandatory_value_types,
          "name",
          "Ext Acc Bill Generate"
        );

   
        name = name.trim();
        description = description.trim();
        reasons =reasons.trim();
        let roleArray  = roles.split(',');
        is_mandatory_value_type_option = is_mandatory_value_type_option == null ? 0 : is_mandatory_value_type_option;
        do_release_value_type_option = do_release_value_type_option == null ? 0 : do_release_value_type_option;
        signature_required_value_type_option = signature_required_value_type_option == null ? 0 : signature_required_value_type_option;
        ext_acc_bill_generate_value_type_option = ext_acc_bill_generate_value_type_option == null ? 0 : ext_acc_bill_generate_value_type_option;
        attachment_required_value_type_option = attachment_required_value_type_option == null ? 0 : attachment_required_value_type_option;
        const param = {
          name,
          description,
          reasons,
          enforced:is_mandatory_value_type_option, 
          do_release : do_release_value_type_option,
          attachment_require :attachment_required_value_type_option,
          signature_require :signature_required_value_type_option,
          ext_acc_bill_generate : ext_acc_bill_generate_value_type_option, 
          roleArray
        };
        console.log({ param });

        const res = await this.$store.dispatch("checkoffTypes/upload", param);
        this.tableLoading = true;
        this.$store.dispatch('checkoffTypes/fetchAllAfterUpload')
        this.tableLoading = false;
        // console.log("response:", res);
        // set status to complete if the upload was successful
        statusRecord.status = statuses.COMPLETE;
      } catch (err) {
        console.error("err", err);
        statusRecord.error_list =
          typeof err.message == "string"
            ? [["error", [err.message]]]
            : Object.entries(err.message);
        statusRecord.status = statuses.ERROR;
      } finally {
        // setLoading(false);
      }
    },
    openModel(){
     
      this.importModal = true;   
     },
     async export_workflow(){
     
            this.tableLoading = true
            await this.$store.dispatch('checkoffTypes/ExportExcel')
            this.tableLoading = false
     }
    },
}
</script>
<style></style>
